/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Level_Intermediate_ReadaptingInputs */

const en_us2_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediate, returning`)
};

const pt_br2_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediário, voltando`)
};

const es_419_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio, retomando`)
};

const pt_pt2_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédio, a regressar`)
};

const fr_fr2_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermédiaire, en reprise`)
};

const de_de2_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortgeschritten, Wiedereinstieg`)
};

const it_it2_profile_level_intermediate_readapting = /** @type {(inputs: Profile_Level_Intermediate_ReadaptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermedio, in ripresa`)
};

/**
* | output |
* | --- |
* | "Intermediate, returning" |
*
* @param {Profile_Level_Intermediate_ReadaptingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_level_intermediate_readapting = /** @type {((inputs?: Profile_Level_Intermediate_ReadaptingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Level_Intermediate_ReadaptingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_level_intermediate_readapting(inputs)
	if (locale === "es-419") return es_419_profile_level_intermediate_readapting(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_level_intermediate_readapting(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_level_intermediate_readapting(inputs)
	if (locale === "de-DE") return de_de2_profile_level_intermediate_readapting(inputs)
	if (locale === "it-IT") return it_it2_profile_level_intermediate_readapting(inputs)
	return en_us2_profile_level_intermediate_readapting(inputs)
});
export { profile_level_intermediate_readapting as "profile.level_intermediate_readapting" }